import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function UnTimeUserListArea(props: any) {
  let myProps = {
    stu_arr: [],
    ...props
  };
  let stu_arr = myProps.stu_arr;
  let un_stu_arr: any = [];
  let select_stu_grade_arr=XcolumnFunc.getSortByTableKey({'table':'user','key':'a_stu_grade'});

  for (let i = 0; i < stu_arr.length; i++) {
    let stu_info = stu_arr[i];
    let is_exist_time = false;
    if (stu_info.lecture_arr && stu_info.lecture_arr.length > 0) {
      is_exist_time = true;
    }
    if (!is_exist_time) {
      un_stu_arr.push(stu_info);
    }
  }

  const get_un_stu_row_tags = () => {
    let tags: any = un_stu_arr.map((stu_info: any, index: number) => {
      let grade_name="";
      for(let i=0;i<select_stu_grade_arr.length;i++){
        if(select_stu_grade_arr[i].value==stu_info.a_stu_grade){
          grade_name=select_stu_grade_arr[i].text;
        }
      };
      return (
        <tr key={index}>
          <td className='text-center'>
            {stu_info.a_user_name}
          </td>
          <td className='text-center'>
            {grade_name}
          </td>
        </tr>
      );
    });
    return tags;
  };
  
  return (
    <div>
      {un_stu_arr.length > 0 &&
        <div className="list-table-div">
          <h5>시간표 미지정 학생 ({un_stu_arr.length}명) </h5>
          <table>
            <colgroup>
              <col width={"100px"}></col>
            </colgroup>
            <tbody>
              {get_un_stu_row_tags()}
            </tbody>
          </table>
        </div>
      }
    </div>
  );
};
export default UnTimeUserListArea;